const ITEMS = [
  "TRAUMA-INFORMED",
  "RECIDIVISM REDUCTION",
  "LEADERSHIP DEVELOPMENT",
  "ADULT FACILITIES",
  "JUVENILE FACILITIES",
  "THE HOOD'S CURRICULUM",
];

export default function KineticMarquee() {
  return (
    <section className="border-y border-white/10 bg-[#151821] py-5 overflow-hidden" data-testid="principles-marquee" aria-hidden="true">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center">
            {ITEMS.map((t, i) => (
              <span key={i} className="flex items-center">
                <span className="font-display font-bold text-lg sm:text-xl tracking-wide text-[#F3F4F6]/60 px-8">{t}</span>
                <span className="text-amber-500 text-sm">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
